/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sara API
 * Sara AI Video Interviewer API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  InviteMemberRequestDto,
  InviteOrganizationMemberParams,
  ListOrganizationMembersParams,
  OrganizationMemberDto,
  RemoveOrganizationMemberParams,
  UpdateMemberRequestDto,
  UpdateOrganizationMemberParams
} from '../model';

import { customFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getInviteOrganizationMemberUrl = (params: InviteOrganizationMemberParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/members?${stringifiedParams}` : `/members`
}

export const inviteOrganizationMember = async (inviteMemberRequestDto: InviteMemberRequestDto,
    params: InviteOrganizationMemberParams, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationMemberDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<OrganizationMemberDto>(getInviteOrganizationMemberUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(inviteMemberRequestDto)
  }
);}





export const getInviteOrganizationMemberMutationKey = () => ['inviteOrganizationMember'] as const;

export const getInviteOrganizationMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteOrganizationMember>>, TError,InviteOrganizationMemberMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteOrganizationMember>>, TError,InviteOrganizationMemberMutationVariables, TContext> => {

const mutationKey = getInviteOrganizationMemberMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteOrganizationMember>>, InviteOrganizationMemberMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  inviteOrganizationMember(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InviteOrganizationMemberMutationResult = NonNullable<Awaited<ReturnType<typeof inviteOrganizationMember>>>
    export type InviteOrganizationMemberMutationBody = InviteMemberRequestDto
    export type InviteOrganizationMemberMutationError = unknown
    export type InviteOrganizationMemberMutationVariables = {data: InviteMemberRequestDto;params: InviteOrganizationMemberParams}

    export const useInviteOrganizationMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteOrganizationMember>>, TError,InviteOrganizationMemberMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inviteOrganizationMember>>,
        TError,
        InviteOrganizationMemberMutationVariables,
        TContext
      > => {
      return useMutation(getInviteOrganizationMemberMutationOptions(options), queryClient);
    }
    export const getListOrganizationMembersUrl = (params: ListOrganizationMembersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/members?${stringifiedParams}` : `/members`
}

export const listOrganizationMembers = async (params: ListOrganizationMembersParams, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationMemberDto[]> => {

  return customFetch<OrganizationMemberDto[]>(getListOrganizationMembersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOrganizationMembersQueryKey = (params?: ListOrganizationMembersParams,) => {
    return [
    `/members`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOrganizationMembersQueryOptions = <TData = Awaited<ReturnType<typeof listOrganizationMembers>>, TError = unknown>(params: ListOrganizationMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationMembers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrganizationMembersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrganizationMembers>>> = ({ signal }) => listOrganizationMembers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrganizationMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrganizationMembersQueryResult = NonNullable<Awaited<ReturnType<typeof listOrganizationMembers>>>
export type ListOrganizationMembersQueryError = unknown


export function useListOrganizationMembers<TData = Awaited<ReturnType<typeof listOrganizationMembers>>, TError = unknown>(
 params: ListOrganizationMembersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationMembers>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganizationMembers<TData = Awaited<ReturnType<typeof listOrganizationMembers>>, TError = unknown>(
 params: ListOrganizationMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationMembers>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganizationMembers<TData = Awaited<ReturnType<typeof listOrganizationMembers>>, TError = unknown>(
 params: ListOrganizationMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationMembers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListOrganizationMembers<TData = Awaited<ReturnType<typeof listOrganizationMembers>>, TError = unknown>(
 params: ListOrganizationMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationMembers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrganizationMembersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateOrganizationMemberUrl = (id: string,
    params: UpdateOrganizationMemberParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/members/${id}?${stringifiedParams}` : `/members/${id}`
}

export const updateOrganizationMember = async (id: string,
    updateMemberRequestDto: UpdateMemberRequestDto,
    params: UpdateOrganizationMemberParams, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationMemberDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<OrganizationMemberDto>(getUpdateOrganizationMemberUrl(id,params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateMemberRequestDto)
  }
);}





export const getUpdateOrganizationMemberMutationKey = () => ['updateOrganizationMember'] as const;

export const getUpdateOrganizationMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationMember>>, TError,UpdateOrganizationMemberMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationMember>>, TError,UpdateOrganizationMemberMutationVariables, TContext> => {

const mutationKey = getUpdateOrganizationMemberMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrganizationMember>>, UpdateOrganizationMemberMutationVariables> = (props) => {
          const {id,data,params} = props ?? {};

          return  updateOrganizationMember(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrganizationMemberMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrganizationMember>>>
    export type UpdateOrganizationMemberMutationBody = UpdateMemberRequestDto
    export type UpdateOrganizationMemberMutationError = unknown
    export type UpdateOrganizationMemberMutationVariables = {id: string;data: UpdateMemberRequestDto;params: UpdateOrganizationMemberParams}

    export const useUpdateOrganizationMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationMember>>, TError,UpdateOrganizationMemberMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrganizationMember>>,
        TError,
        UpdateOrganizationMemberMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOrganizationMemberMutationOptions(options), queryClient);
    }
    export const getRemoveOrganizationMemberUrl = (id: string,
    params: RemoveOrganizationMemberParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/members/${id}?${stringifiedParams}` : `/members/${id}`
}

export const removeOrganizationMember = async (id: string,
    params: RemoveOrganizationMemberParams, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getRemoveOrganizationMemberUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveOrganizationMemberMutationKey = () => ['removeOrganizationMember'] as const;

export const getRemoveOrganizationMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOrganizationMember>>, TError,RemoveOrganizationMemberMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeOrganizationMember>>, TError,RemoveOrganizationMemberMutationVariables, TContext> => {

const mutationKey = getRemoveOrganizationMemberMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeOrganizationMember>>, RemoveOrganizationMemberMutationVariables> = (props) => {
          const {id,params} = props ?? {};

          return  removeOrganizationMember(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveOrganizationMemberMutationResult = NonNullable<Awaited<ReturnType<typeof removeOrganizationMember>>>

    export type RemoveOrganizationMemberMutationError = unknown
    export type RemoveOrganizationMemberMutationVariables = {id: string;params: RemoveOrganizationMemberParams}

    export const useRemoveOrganizationMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOrganizationMember>>, TError,RemoveOrganizationMemberMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeOrganizationMember>>,
        TError,
        RemoveOrganizationMemberMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveOrganizationMemberMutationOptions(options), queryClient);
    }
